import axios from "axios";
import React from "react";
import { Text, Switch } from "@mantine/core";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
export default function BulkCommunicationAllowToggle({
  locationId,
  organizationId,
  fetchData,
  value,
  disabled,
  smsMarketing = false,
  transactionalSms = false,
  conversationalSms = false,
}) {
  const { t } = useTranslation();
  function changeStatus() {
    const req = {};
    if (locationId) req.location_id = locationId;
    if (organizationId) req.organization_id = organizationId;

    axios
      .post(
        transactionalSms
          ? `/bulk-communicators/toggle-transactional-sms/`
          : smsMarketing
          ? `/bulk-communicators/toggle-sms-marketing/`
          : conversationalSms
          ? `/bulk-communicators/toggle-conversational-sms/`
          : `/bulk-communicators/toggle-email-marketing/`,
        req
      )
      .then(() => {
        toast.success(t("common:updated") + "!");
        fetchData();
      })
      .catch((err) => {
        toast.error(err);
      });
  }

  return (
    <React.Fragment>
      {disabled && (
        <Text fw={600} mb="sm" size="sm">
          To access this setting, create a Postmark server first.
        </Text>
      )}
      <Switch
        color="green"
        label={
          transactionalSms
            ? "Allow Transactional SMS"
            : smsMarketing
            ? "Allow SMS Marketing"
            : conversationalSms
            ? "Allow Conversational SMS"
            : "Allow Email Marketing"
        }
        disabled={disabled}
        onClick={() => changeStatus()}
        checked={value}
      />
    </React.Fragment>
  );
}
